import { render } from "./JIRA_SYNCHRONIZATION_DISABLED.vue?vue&type=template&id=9c805222&ts=true"
import script from "./JIRA_SYNCHRONIZATION_DISABLED.vue?vue&type=script&lang=ts"
export * from "./JIRA_SYNCHRONIZATION_DISABLED.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__